import React, { useState, useEffect, useRef } from 'react';
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';

import useLocalStorage from 'use-local-storage';

import "./Contact.css";
import { FaEnvelope } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { FaInfoCircle } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { BsDiscord } from 'react-icons/bs';
import { FaHashnode } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa";
// import Footer from '../Footer';
import BackToTop from '../BackToTop';
import Marque from '../Marque';
import Footer1 from '../footer/Footer1';
import AOS from 'aos';
import Navbar from '../navbar/Navbar';


const Contact = () => {

    const [userName, setUserName] = useState("")
    const [userEmail, setUserEmail] = useState("")
    const [userMessage, setUserMessage] = useState("")
    const [isSubmitting, setIsSubmitting] = useState(false)
    const form = useRef();


    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        setTimeout(() => {

            setIsLoading(false);
        }, 1000);
    }, [])

    const [theme,] = useLocalStorage('theme' ? 'dark' : 'light')


    useEffect(() => {
        AOS.init();
        // Initialize EmailJS with your public key
        emailjs.init('Hb7u-ezPMszTTNtwQ');
    }, [])


    const sendEmail = (e) => {
        e.preventDefault();

        if (isSubmitting) return; // Prevent multiple submissions

        setIsSubmitting(true);

        emailjs
            .sendForm(
                'service_tnpu19h',
                'template_3cchj1k',
                form.current,
                'Hb7u-ezPMszTTNtwQ'
            )
            .then((result) => {
                // Show success message
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Message sent successfully!',
                    showConfirmButton: false,
                    timer: 3000
                });

                // Reset form
                setUserName("")
                setUserEmail("")
                setUserMessage("")
                form.current.reset();

            }, (error) => {
                console.error('EmailJS Error:', error);
                console.error('Error details:', error.text);

                let errorMessage = 'Failed to send message. Please try again.';

                // Provide specific error messages
                if (error.text && error.text.includes('Account not found')) {
                    errorMessage = 'EmailJS account not found. Please check your public key.';
                } else if (error.text && error.text.includes('Invalid')) {
                    errorMessage = 'Invalid EmailJS configuration. Please check your service and template IDs.';
                } else if (error.text && error.text.includes('quota')) {
                    errorMessage = 'Email quota exceeded. Please try again later.';
                }

                // Show error message
                Swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: errorMessage,
                    showConfirmButton: false,
                    timer: 4000
                });
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    // Remove the old alertMe function as it's now handled in sendEmail

    const areAllFieldsFilled = (userName !== "") && (userEmail !== "") && (userMessage !== "")





    return (
        <>
            {
                isLoading ? (<div className="load" data-theme={theme}><hr /><hr /><hr /><hr /></div>) : (
                    <div className='contact_container'>
                        <Navbar />
                        <div className='contact_first_div'>
                            <div className='contact_sub_div'>
                                <h1>Get in <span>Touch</span></h1>
                                <p>Have a project in mind or want to discuss how I can help with your Web development needs? Feel free to reach out.</p>
                            </div>
                            <div className='contact_sub_right'></div>
                        </div>

                        <div className='contact_inner_div'>
                            <div className='contact_inner_left'>
                                <div className='contact_inner_inner_div'>
                                    <div className='contact_info_sec'>
                                        <span><FaEnvelope style={{ fontSize: "1.5em", color: "#8c1985" }} /></span>
                                        <div>
                                            <p>Email</p>
                                            <p>
                                                <a href="mailto:uakubue@gmail.com"><email>uakubue@gmail.com</email></a>
                                            </p>
                                        </div>
                                    </div>

                                    <div className='contact_info_sec'>
                                        <span><FaLocationDot style={{ fontSize: "1.5em", color: "#8c1985" }} /></span>
                                        <div>
                                            <p>Location</p>
                                            <p>
                                                Lagos, Nigeria
                                            </p>
                                        </div>
                                    </div>

                                    <div className='contact_info_sec'>
                                        <div><span><FaInfoCircle style={{ fontSize: "1.5em", color: "#8c1985" }} /></span></div>
                                        <div>
                                            <p>Availability</p>
                                            <p>
                                                Open to both remote and Hybrid opportunities
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <p>Feel free to reach out anytime for collaborative opportunities.</p>
                            </div>

                            <div className='contact_inner_right'>
                                <h2>Connect With Me</h2>
                                <div className='contact_right_inner_inner_div'>
                                    <a href='https://github.com/uakubue' target='blank'>
                                        <div className='contact_info_sec'>
                                            <span><FaGithub style={{ fontSize: "1.7em", color: "#8c1985" }} /></span>
                                            <div>
                                                <p>Github</p>
                                            </div>
                                        </div>
                                    </a>

                                    <a href='https://x.com/holmesakubue' target='blank'>
                                        <div className='contact_info_sec'>
                                            <span><FaXTwitter style={{ fontSize: "1.7em", color: "#8c1985" }} /></span>
                                            <div>
                                                <p>X / Twitter</p>
                                            </div>
                                        </div>
                                    </a>

                                    <a href='https://www.linkedin.com/in/uchenna-akubue-490921120/' target='blank'>
                                        <div className='contact_info_sec'>
                                            <span><FaLinkedinIn style={{ fontSize: "1.7em", color: "#8c1985" }} /></span>
                                            <div>
                                                <p>LinkedIn</p>
                                            </div>
                                        </div>
                                    </a>

                                    <a href='https://hashnode.com/@cholanTechSolutions' target='blank'>
                                        <div className='contact_info_sec'>
                                            <span><FaHashnode style={{ fontSize: "1.7em", color: "#8c1985" }} /></span>
                                            <div>
                                                <p>Hashnode</p>
                                            </div>
                                        </div>
                                    </a>

                                    <a href='https://discord.com/users/921015076234862593' target='blank'>
                                        <div className='contact_info_sec'>
                                            <span><BsDiscord style={{ fontSize: "1.7em", color: "#8c1985" }} /></span>
                                            <div>
                                                <p>Discord</p>
                                            </div>
                                        </div>
                                    </a>


                                </div>
                                <p>Follow me on social media for updates on my latest projects and articles.</p>
                            </div>
                        </div>



                        <div className='message_box_section'>
                            <div className='form_section'>

                                <form ref={form} onSubmit={sendEmail}>
                                    <h5>Kindly send me a message</h5>
                                    <input className='input_box1' type="text" name='user_name' placeholder='Your Name' value={userName} onChange={e => setUserName(e.target.value)} required minLength={4} maxLength={50} /><br />

                                    <input className='input_box2' type="email" name='user_email' id='user_email' placeholder='Your Email' value={userEmail} onChange={e => setUserEmail(e.target.value)} required minLength={5} maxLength={50} /><br />

                                    <textarea className='input_box3 ' name='message' rows={7} placeholder="Type your Message Here" value={userMessage} onChange={e => setUserMessage(e.target.value)} required minLength={4}></textarea><br />

                                    <button disabled={!areAllFieldsFilled || isSubmitting} id='resume_btn' type='submit' value="send">
                                        {isSubmitting ? 'Sending...' : 'Submit'}
                                    </button>
                                </form>
                            </div>
                        </div>

                        {/* Google Map Section */}
                        <div className="map_section py-10">
                            <div className="map_container overflow-hidden border border-[var(--border)]">
                                <iframe
                                    title="Lekki Map"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d63426.04631393696!2d3.450417684841968!3d6.453303867664687!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103bf452da331527%3A0x6fa7963d3fb66817!2sLekki%2C%20Lagos!5e0!3m2!1sen!2sng"
                                    width="100%"
                                    height="450"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                ></iframe>
                            </div>
                        </div>
                        <Marque />
                        <Footer1 />
                        <BackToTop />
                    </div>
                )
            }
        </>
    )
}

export default Contact